import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'userTimezoneFormat',
  pure: false
})

export class UserTimezoneFormatPipe implements PipeTransform {
  transform(value: any, typeFormat: number): string {
    if (value == null || value === '') return '';
    const userTz = sessionStorage.getItem('userTimeZoneIANA');
    if (!userTz) return '';

    try {
      // Handle special cases first
      if (typeFormat === 5) {
        // ISO UTC (without converting to user's timezone)
        const utcMoment = moment.utc(value);
        return utcMoment.isValid() ? utcMoment.format('YYYY-MM-DDTHH:mm:ss.SSS') : '';
      }

      if (typeFormat === 6) {
        // Compact format YYYYMMDDHHmm -> user local timezone
        const isCompact = typeof value === 'string' && /^\d{12}$/.test(value);
        if (!isCompact) return String(value);
        const parsed = moment.utc(value, 'YYYYMMDDHHmm');
        return parsed.isValid() ? parsed.tz(userTz).format('MM/DD/YYYY hh:mm A') : '';
      }

      if (typeFormat === 7) {
        // Show time only, keep local time (no timezone conversion)
        if (typeof value === 'string') {
          const mOrigin = moment.parseZone(value);
          if (mOrigin.isValid()) {
            return mOrigin.format('HH:mm');
          }
        }
        if (value instanceof Date) {
          return moment(value).format('HH:mm');
        }
        return '';
      }

      // Convert to user's timezone (DST handled by moment-timezone)
      const localMoment = moment.utc(value).tz(userTz);
      if (!localMoment.isValid()) return '';

      switch (typeFormat) {
        case 1:
        case 8:
          return localMoment.format('MM/DD/YYYY hh:mm A');
        case 2:
          return localMoment.format('MM/DD/YYYY');
        case 3:
          return localMoment.format('hh:mm A');
        case 4:
          // Use real millisecond precision (moment does not support higher precision)
          return localMoment.format('YYYY-MM-DDTHH:mm:ss.SSS');
        case 9:
          return localMoment.format('YYYY/MM/DD HH:mm:ss');
        case 10:
          return localMoment.format('DD/MM/YYYY HH:mm:ss');
        default:
          return localMoment.format('YYYY-MM-DD HH:mm:ss');
      }
    } catch (err) {
      console.warn('[userTimezoneFormat] formatting error', err);
      return '';
    }
  }
}
